import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { heading4Obj, heading5Obj } = typographyStyles;

export const homepageDefaultRowContainerCss: CSSObject = {
  padding: "1rem",
  borderRadius: "1rem",
  background: constants.colors.ui.white[50],

  display: "grid",
  gridTemplateColumns: "1rem 1fr 1rem",
  gridTemplateRows: "auto auto 1fr",

  [mediaQuery.downTo(constants.breakpoints.Breakpoints.xs)]: {
    padding: "1.5rem",
  },
};

export const defaultHeadingCss: CSSObject = {
  ...heading4Obj,
  fontWeight: 700,
  color: constants.colors.ui.neutral[700],
  display: "flex",
  alignItems: "center",
};

export const headerDescriptionCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  ...heading5Obj,
  lineHeight: "137.5%",
  color: constants.colors.ui.neutral[600],
};

export const headerIconCss: CSSObject = {
  marginRight: "5px",
  width: "24px",
  height: "24px",
};

export const headerAndDescriptionContainerCss: CSSObject = {
  gridColumn: "1 / -1",
  gridRow: "1 / 3",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  marginBottom: "0.25rem",
};

export const linkCss = {
  root: {
    padding: "0.25rem 0.5rem",
    marginLeft: "0.25rem",
    color: constants.colors.ui.core[700],
  },
};

export const contentScrollableListCss: CSSObject = {
  width: "100%",
  display: "flex",
};

export const listItemCss: CSSObject = {
  width: "fit-content",
  margin: "0 6px",
};

export const lunaContainerCss: CSSObject = {
  marginLeft: "auto",
};
